<div
  *ngIf="isOpen"
  aria-labelledby="modal-title"
  role="dialog"
  aria-modal="true"
  class="overlay !z-[9998] fixed inset-0 bg-transparent backdrop-blur-[2px] flex items-center justify-center"
  >
  <!-- bg-transparent backdrop-blur-[2px] css for transparent and blur : old: bg-black bg-opacity-50 -->
  <div class="popupForStatus bg-white shadow-[0px_10px_10px_-5px_rgba(0,0,0,0.04),0px_20px_25px_-5px_rgba(0,0,0,0.10)] {{poupWidth}} w-full mx-4">
    <!-- Placeholder Image -->
    <div *ngIf="imageSrc" class="flex justify-center mb-3">
      <img [src]="imageSrc" alt="popup-icon" class="object-contain {{ imageCss }}" />
    </div>

    <!-- Heading -->
    <h1 *ngIf="heading" class="{{headingCss}}">
      {{ heading }}
    </h1>

    <!-- Subtext -->
    <div [ngClass]="heading ?'my-3':''">
        <ng-content></ng-content> 
    </div>
    

    <!-- Actions -->
    <!-- Container: Use 'justify-center' and 'gap-x-3' for the 50/50 split -->
    <div 
    class="flex mt-6"
    [ngClass]="isFullWidthButtons ? 'justify-center gap-x-4' : 'justify-end'"
    >
    <!-- Cancel Button -->
    <button
        *ngIf="closeButtonText"
        type="button"
        class="border   {{closeButtonTextCss}} transition-all"
        [ngClass]="isFullWidthButtons ? 'flex-1' : 'px-3 mr-3'"
        (click)="close()"
    >
        {{ closeButtonText }}
    </button>

    <!-- Confirm Button -->
    <button
        *ngIf="confirmButtonText"
        type="button"
        class="{{confirmButtonTextCss}}  hover:opacity-90 transition-all"
        [ngClass]="isFullWidthButtons ? 'flex-1' : 'px-5'"
        [disabled]="isConfirmDisabled"
        (click)="confirm()"
    >
        {{ confirmButtonText }}
    </button>
    </div>
  </div>
</div>




<!-- Sample code :- How to use  -->

<!-- <app-common-popup
  [isOpen]="confirmReviewModal"
  [imageSrc]="_commonService.Images.REVIEW_PRIMARY_COLOR_ICON"
  [imageCss]="'h-16 w-16'"
  [heading]="'Are you sure to review?'"
  [headingCss]="'text-center text-primary_Text_Color text-xl poppinsSemiBold mb-2 '"
  [isFullWidthButtons] = "true"
  [closeButtonText]="'Cancel'"
  [confirmButtonText]="'Yes, continue'"
  (onClose)="confirmReviewModal = false"
  (onConfirm)="getManualQuestions()"
>
 <p class="text-secondary_Light_Text_Color w- poppinsRegular text-sm">
          This Action will give you fixed set of questions and you will no
          longer be able to add sub sections
        </p>
</app-common-popup> -->